import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as Actions from '../actions/budget-vs-actual-config.actions';
import { BudgetVsActualConfigData } from '../models/budget-vs-actual-config-data.model';

export class BudgetVsActualConfigState {
  id: number;
  loading?: boolean;
  data?: BudgetVsActualConfigData;
}

export const adapter: EntityAdapter<BudgetVsActualConfigState> = createEntityAdapter<BudgetVsActualConfigState>();

export interface State extends EntityState<BudgetVsActualConfigState>{}

export const initialState: State = adapter.getInitialState({
  id: undefined,
  loading: false,
  data: undefined
});

const budgetVsActualConfigReducer = createReducer(
  initialState,
  on(Actions.BudgetConfigDataLoad, (state, { widgetConfigId }) => {
    const instance: BudgetVsActualConfigState = {
        id: widgetConfigId,
        loading: true,
        data: null
    };
    return adapter.upsertOne(instance, state);
  }),
  on(Actions.BudgetConfigDataLoadComplete, (state, { widgetConfigId, data }) => {
    return adapter.updateOne(
      { id: widgetConfigId, changes: { loading: false, data: data } },
      state
    );
  }),

  on(Actions.Clear, (state, { widgetConfigId }) => {

    return adapter.updateOne({
      id: widgetConfigId,
      changes: {
        loading: undefined,
        data: undefined
      }
    }, state);
  })
);

export function reducer(state: State | undefined, action: Action) {
   return budgetVsActualConfigReducer(state, action);
}
